import {
  FormControl,
  InputLabel,
  Input,
  FormHelperText,
  Button,
} from "@mui/material";
import { Typography } from "@mui/material";

import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";

import {
  getAuth,
  createUserWithEmailAndPassword,
  updateProfile,
} from "firebase/auth";
import { db } from "../firebase.config";
import { setDoc, doc, serverTimestamp } from "firebase/firestore";
import { toast } from "react-toastify";

function SignUpForm() {
  // const [showPassword, setShowPassword] = useState(false);
  const [userData, setUserData] = useState({
    name: "",
    email: "",
    password: "",
  });

  const { name, email, password } = userData;

  const navigate = useNavigate();

  const onChange = (e) => {
    setUserData((prevState) => ({
      ...prevState,
      [e.target.id]: e.target.value,
    }));
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    try {
      const auth = getAuth();

      const userCredential = await createUserWithEmailAndPassword(
        auth,
        email,
        password
      );

      const user = userCredential.user;

      updateProfile(auth.currentUser, {
        displayName: name,
      });

      const userDataCopy = { ...userData };
      delete userDataCopy.password;
      userDataCopy.timeStamp = serverTimestamp();

      await setDoc(doc(db, "users", user.uid), userDataCopy);

      navigate("/");
    } catch (error) {
      console.log("error :", error.message);
      if (error.message.includes("Password should be at least 6 characters")) {
        toast.error("Password must be 6 or more characters!");
      } else {
        toast.error("Something went wrong with registration");
      }
    }
  };
  return (
    <>
      <Typography variant="h3" component="h2">
        Sign Up
      </Typography>
      <br />
      <form onSubmit={onSubmit}>
        <div>
          <FormControl fullWidth>
            <InputLabel htmlFor="name">Name</InputLabel>
            <Input
              type="text"
              name="name"
              id="name"
              value={name}
              onChange={onChange}
            />
          </FormControl>
        </div>
        <br />
        <div>
          <FormControl fullWidth>
            <InputLabel htmlFor="email">Email address</InputLabel>
            <Input
              id="email"
              value={email}
              aria-describedby="email-helper-text"
              onChange={onChange}
            />
            <FormHelperText id="email-helper-text">
              We'll never share your email.
            </FormHelperText>
          </FormControl>
        </div>
        <br />
        <div>
          <FormControl fullWidth>
            <InputLabel htmlFor="password">Password</InputLabel>
            <Input
              id="password"
              aria-describedby="password-helper-text"
              value={password}
              onChange={onChange}
            />
          </FormControl>
        </div>
        <br />
        <div>
          <Button
            color="info"
            size="large"
            variant="contained"
            fullWidth
            type="submit"
            sx={{ textTransform: "none" }}
          >
            Submit
          </Button>
        </div>
      </form>
      <p>
        Already have an account? <Link to="/">Login Here</Link>
      </p>
    </>
  );
}

export default SignUpForm;
